module.exports = __webpack_public_path__ + "static/menu-icon-diamond.eb53b62a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/img/menu-icon-diamond.svg
// module id = 1408
// module chunks = 114276838955818